import HomeComponent from '../HomeComponent'

export default [
    {
        path: '/sb3d_page',
        component: HomeComponent,
        name: 'sb3d_page',
    }
]